<template>
  <b-form>
    <b-form-group label="Description">
      <b-form-textarea
        class="resize-none"
        @change="setValue('description', $event)"
        :state="validateState('description')"
        v-model.trim="$v.form.description.$model"
        aria-describedby="input-description-live-feedback"
      />
      <b-form-invalid-feedback id="input-description-live-feedback">
        This is a required field.
      </b-form-invalid-feedback>
    </b-form-group>

    <div class="text-right mt-2">
      <b-button
        :disabled="$v.form.$invalid || saveNote === 'fetching'"
        variant="primary"
        @click="addNote()"
      >
        <b-spinner v-if="saveNote === 'fetching'" variant="white" small />
        <span v-else>{{ $t("submit") }}</span>
      </b-button>
    </div>
  </b-form>
</template>

<script>
import { mapState } from "vuex";
import { required } from "vuelidate/lib/validators";
import { POST_VEHICLE_NOTE } from "../actions";
import { superAdminMixin } from "../../mixins";
export default {
  props: ["vehicle"],
  mixins: [superAdminMixin],
  data() {
    return {
      form: {
        description: null,
        vehicleId: null,
      },
    };
  },
  computed: {
    ...mapState({
      saveNote: (state) => state.superAdminStore.componentStore.saveNote.status,
    }),
  },
  validations: {
    form: {
      description: {
        required,
      },
    },
  },
  methods: {
    setValue(key, value) {
      this.form[key] = value;
      this.$v.form[key].$touch();
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form.description = null;
      this.form.vehicleId = null;
      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    addNote() {
      if (this.$v.form.$invalid) return;
      this.form.vehicleId = this.vehicle.id;
      this.$store
        .dispatch(POST_VEHICLE_NOTE, this.form)
        .then(() => {
          this.resetForm();
          this.getNotes(true, this.vehicle);
          this.toastMessage("Note saved", "Success", "success");
          this.getVehiclesInfo();
        })
        .catch(() => {
          this.toastMessage("Note could not saved", "Warning", "warning");
        });
    },
  },
};
</script>

<style></style>
